/******/ (() => { // webpackBootstrap
    var __webpack_exports__ = {};
    window.PXUTheme.jsReviewsCarousel = {
        init: function ($section) {

            // Add settings from schema to current object
            window.PXUTheme.jsReviewsCarousel = $.extend(this, window.PXUTheme.getSectionData($section));

            // Selectors
            const $reviewsCarouselEl = $section.find('[data-reviews-carousel]').removeClass('is-hidden');

            const $reviewsCarousel = $reviewsCarouselEl.flickity({
                wrapAround: true,
                autoPlay: 5000,
                adaptiveHeight: false,
                draggable: true,
                imagesLoaded: true,
                fade: false,
                freeScroll: false,
                contain: false,
                pauseAutoPlayOnHover: true,
                selectedAttraction: 0.01,
                friction: 0.15,
                setGallerySize: true,
                cellAlign: 'center',
                prevNextButtons: false,
                pageDots: false,
                watchCSS: true
            });

            // After Flickity initialization:
            const flkty = $reviewsCarousel.data('flickity');

            // Resize flickity when the slider is settled and after images load
            $reviewsCarouselEl.on('settle.flickity ready.flickity load.flickity', function () {
                $reviewsCarouselEl.flickity('resize');
            });

            // $reviewsCarouselEl.on('dragEnd.flickity', function() {
            //     flkty.playPlayer();
            // });

            // $reviewsCarouselEl.on('select.flickity', function() {
            //     flkty.playPlayer();
            // });

            // $reviewsCarouselEl.on('dragEnd.flickity', function() {
            //     flkty.playPlayer();
            // });
            

        },
        blockSelect: function ($section, blockId) {
            const $slider = $section.find('[data-reviews-carousel]');
            const $sliderIndex = $('#shopify-section-' + blockId).data('slide-index');

            $slider.flickity('select', $sliderIndex, true, true);

        },
        unload: function ($section) {

        }
    }

    /******/
})()
    ;